export default "__VITE_ASSET__D7j8f65x__"